const Empty = require('constants/empty');
const { createSelector } = require('reselect');
const { userSelector } = require('selectors/user/userSelector');
const beautyInsiderAccountSelector = createSelector(userSelector, user => user.beautyInsiderAccount || Empty.Object);

module.exports = { beautyInsiderAccountSelector };
